import ApiService from "../../../common/api.service";

export async function GetLoyaltyPurchases({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("LOYALTY_PURCHASE_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/loyalty/purchase-history", option);
    commit("LOYALTY_PURCHASE_SUCCESS", _response.data);
  } catch (error) {
    commit("LOYALTY_PURCHASE_ERROR", { result: error.message });
  }
}
